import { generateRequest } from '@/api/generateRequest'

const config = {
    getOpenId: {
        url: '/client/wx/getOpenId',
        apiType: 'check',
    },
    userBind: {
        url: '/client/wx/bing',
    },
	
    cancelUserBind: { 
        url: '/client/wx/cancelBing',
    },
    listPerson: { 
        url: '/client/wx/listPerson',
        apiType: 'check',
    },
    changePerson: { 
        url: '/client/wx/changePerson',
        apiType: 'check',
    },
    deletePerson: { 
        url: '/client/wx/deletePerson',
        apiType: 'check',
    },
    checkToken: { 
        url: '/client/wx/checkToken',
        apiType: 'check',
    },
    userDetail: {
		url: '/client/person/get',
		apiType: 'check',
    },
    update: {
		url: '/client/person/update',
		apiType: 'check',
	},
	userTitle: {
		url: '/client/person/get/use/default/title',
		apiType: 'check'
	}
}

const apiUserPage = {
	getOpenId: (data, variable) => generateRequest(data, config.getOpenId, variable),
    userBind: (data, variable) => generateRequest(data, config.userBind, variable),
    cancelUserBind: (data, variable) => generateRequest(data, config.cancelUserBind, variable),
    listPerson: (data, variable) => generateRequest(data, config.listPerson, variable),
    changePerson: (data, variable) => generateRequest(data, config.changePerson, variable),
    deletePerson: (data, variable) => generateRequest(data, config.deletePerson, variable),
    checkToken: (data, variable) => generateRequest(data, config.checkToken, variable),
    userDetail: (data, variable) => generateRequest(data, config.userDetail, variable),
    update: (data, variable) => generateRequest(data, config.update, variable),
    userTitle: (data, variable) => generateRequest(data, config.userTitle, variable),
}
export default apiUserPage
